import { FadeIn } from '../../components/ui/AnimatedSection';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

export default function Hero() {
  const { t } = useTranslation();
  return (
    <div className="relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background with zoom effect */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat transition-transform duration-[20s] ease-out hover:scale-110"
        style={{ 
          backgroundImage: 'url("/assets/luxury_interior.webp")',
        }}
      >
        <div className="absolute inset-0 bg-black-deep/60"></div>
      </div>

      <FadeIn className="relative z-10 text-center px-4 max-w-4xl mx-auto mt-20">
        <span className="text-gold-400 font-serif italic text-xl md:text-2xl mb-6 block tracking-wide">
          {t('hero.subtitle')}
        </span>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-white mb-8 leading-tight drop-shadow-lg">
          {t('hero.title1')} <br/>
          <span className="text-gold-300">{t('hero.title2')}</span>
        </h1>
        <p className="text-gray-200 text-lg md:text-xl font-light mb-12 max-w-2xl mx-auto drop-shadow-md">
          {t('hero.desc')}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <a href="#simulateur" className="w-full sm:w-auto px-10 py-4 bg-gradient-to-r from-gold-400 to-gold-600 text-white text-sm uppercase tracking-widest rounded-full shadow-[0_8px_20px_rgba(201,152,85,0.4)] hover:shadow-[0_12px_30px_rgba(201,152,85,0.6)] hover:-translate-y-1 transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-white inline-block text-center">
            {t('hero.btnEstimate')}
          </a>
          <Link to="/audit" className="w-full sm:w-auto px-10 py-4 border border-white text-white text-sm uppercase tracking-widest rounded-full hover:bg-white hover:text-black-deep transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 inline-block text-center">
            {t('hero.btnJoin')}
          </Link>
        </div>

        <div className="mt-12 inline-flex items-center justify-center gap-2 bg-black-deep/40 backdrop-blur-sm border border-gold-500/30 rounded-full px-6 py-3">
          <MapPin className="text-gold-400 w-5 h-5 flex-shrink-0" />
          <span className="text-white text-sm md:text-base font-light tracking-wide">
            {t('common.exclusiveSector')}
          </span>
        </div>
      </FadeIn>
    </div>
  );
}
